import axios from 'axios'

import env from 'env'

import { request } from '../request'
import { extractResponseData } from '../utils'

/*
 * NOTE: We have changed this endpoint to be authentication required
 * TODO: Rename publicMessaging instance and state to be messaging
 */

const publicMessagingApiInstance = axios.create({
  baseURL: `${env.USER_API_URL}/api/v2/user/messaging`,
})

publicMessagingApiInstance.interceptors.request.use(request)
publicMessagingApiInstance.interceptors.response.use(extractResponseData)

export { publicMessagingApiInstance }

export default publicMessagingApiInstance
